import React from 'react';
import {
  Grid, Box, makeStyles, Tooltip,
} from '@material-ui/core';
import SearchPickup from 'views/motorcycle_rental/components/widget/SearchPickup';
import SearchDropoff from 'views/motorcycle_rental/components/widget/SearchDropoff';
import { withTranslation } from 'config/i18n';
import SameLocationCheckBox from 'views/motorcycle_rental/components/widget/SameLocationCheckBox';
import TooltipStyle from 'views/motorcycle_rental/components/widget/TooltipStyle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

const useStyles = makeStyles((theme) => ({
  searchPickupGrid: {
    height: '100%',
    width: '100%',
    flex: 1,
    // [theme.breakpoints.up('lg')]: {
    //   display: 'flex',
    // },
  },
  placeBox: {
    height: '100%',
    display: 'flex',
    width: '100%',
    flex: '1',
    [theme.breakpoints.only('sm')]: {
      flexDirection: 'column',
    },
  },
  searchDropoffGrid: {
    '& svg': {
      width: theme.spacing(2),
      height: theme.spacing(2),
      margin: theme.spacing(0.5, 0.5, 0, 0),
    },
  },
  ...TooltipStyle(theme),
}));

const SearchPlace = (props) => {
  const {
    t, data, hideDropoff, readOnly = false,
  } = props;
  const classes = useStyles();
  const { sameLocation, handleSameLocationClick } = data;

  return (
    <Box className={classes.placeBox}>
      <Grid item md={12} lg={hideDropoff ? 7 : 12} className={classes.searchPickupGrid}>
        <SearchPickup
          data={{
            ...data,
            disableClearable: true,
            label: sameLocation
              ? t('fe_es_geo_widget:place.pickup_dropoff')
              : t('fe_es_geo_widget:place.pickup'),
            checkBoxShown: data.selectedPickupPlace && sameLocation, // this passed to the autocomplete for style purposes
            noCheckBoxNorDropoff: !data.selectedPickupPlace,
          }}
          readOnly={readOnly}
        />
        {/* CHECKBOX appears if there is a Pickup Place selected && there is Dropoff Geos for the Selected Pickup Place */}
        { !hideDropoff
          && data.selectedPickupPlace
          && sameLocation
            && (
              <>
                {(data.dropoffGeos.length > 0)
                  ? (
                    <SameLocationCheckBox
                      checked={sameLocation}
                      onChange={() => handleSameLocationClick(!sameLocation)}
                    />
                  )
                  : (
                    <Tooltip
                      arrow
                      classes={{
                        arrow: classes.tooltipArrowOverride,
                        tooltip: classes.tooltipOverride,
                      }}
                      enterTouchDelay={10}
                      title={(
                        <>
                          <ErrorOutlineIcon />
                          {t('fe_es_geo_widget:place.disable_return_location')}
                        </>
                      )}
                    >
                      <Box>
                        <SameLocationCheckBox
                          checked={sameLocation}
                          onChange={() => handleSameLocationClick(!sameLocation)}
                          disabled
                        />
                      </Box>
                    </Tooltip>
                  )}
              </>
            )}
      </Grid>
      {!hideDropoff
        && data.selectedPickupPlace
        && !sameLocation
        && (
          <Grid item className={classes.searchDropoffGrid}>
            <SearchDropoff data={{
              ...data,
              onCloseClick: () => handleSameLocationClick(true),
            }}
            />
          </Grid>

        )}
    </Box>
  );
};
export default withTranslation(['fe_es_geo_widget'])(SearchPlace);
